// utils/parseLinks.js
export function parseLinks(text, linkMap) {
  const regex = /\[([a-z0-9_]+):([^\]]+)\]/gi;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const [fullMatch, key, label] = match;
    const start = match.index;

    // Add text before the link
    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }

    // Add the link
    parts.push(
      <a
        key={key + start}
        href={linkMap[key]}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-700 underline"
      >
        {label}
      </a>
    );

    lastIndex = regex.lastIndex;
  }

  // Add the remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
}
